var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interview-control"},[_c('OfflineQualityControl',{attrs:{"reviewTitle":'电话审核',"reviewContent":'对电话访问的答卷进行人工审核',"powerSubTitle":'（开启答题过程质控后，可在答卷详情中查看质控证据）',"powerContent":'调查员可见电话调查时记录的多媒体素材'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }